import axios from "axios";
import { endpoints } from "../_config";

class UserApiKeysService {
  /**
   * Get the groups by user
   * @param {User} user
   */
  static async createKey(user, keyName) {
    return axios
      .post(
        endpoints.user.apiKeys.get,
        {
          name: keyName,
        },
        {
          headers: {
            Authorization: "Bearer " + user.token,
          },
        }
      )
      .then((response) => response.data);
  }

  /**
   * Delete api key
   * @param {User} user
   */
  static async deleteKey(user, keyId) {
    return axios
      .delete(endpoints.user.apiKeys.delete(keyId), {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }

  /**
   * Get meeting data for meetingId
   * @param {*} user
   * @param {*} meetingId
   * @returns
   */
  static async getKeys(user) {
    return axios
      .get(endpoints.user.apiKeys.get, {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      })
      .then((response) => response.data);
  }
}

export { UserApiKeysService };
